import { useState } from "react";

import { SOWiseLocationList } from "../../services/warehouseService";

export const useSOWiseLocationList = () => {

    const [warehouseLocationListBySO, setWarehouseLocationListBySO] = useState([]);

    const fetchWarhouseLocationListBySO = async (locationid) => {
        const para = { p_so_number: locationid, p_companyid: localStorage.getItem("companyid"), };

        try {
            const data = await SOWiseLocationList(para);
            setWarehouseLocationListBySO(data || []);
            return data || []; // 🔥 return fetched data directly
        } catch (error) {
            alert(error.message);
        }
    };

    return {
        warehouseLocationListBySO,
        fetchWarhouseLocationListBySO,
        setWarehouseLocationListBySO,   // optional – if you need reset
    };
};
